import { AlphaDCircleIcon } from './AlphaDCircleIcon';

/**
 * author: Contributors
 * id 758D2479-2950-4C5E-8FDC-C0FFA2EBE114
 * name alpha-d-circle
 * version: 3.2.89
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/alpha-d-circle.svg
 * tags
 * - Alpha / Numeric 
 */
export const AlphabetDCircleIcon = AlphaDCircleIcon;
export default AlphabetDCircleIcon